//export const BASE_URL = 'https://localhost:7190/api/';
//export const BASE_URL = 'https://lunchandlearn.calibermatrix.com/api/';
export const BASE_URL = "https://lunch-and-learn-prod-api-akdxexa3c4evc8bq.canadacentral-01.azurewebsites.net/api/"
export const Endpoints = {
  GetUpcomingEvents: 'Events/GetUpcomingEvents',
  CreateUpdateEvent: 'Events/CreateUpdateEvent',
  DeleteEvent: 'Events/DeleteEvent',
  GetPastEvents: 'Events/GetPastEvents',
  AddUpdateEventRecording: 'Events/AddUpdateEventRecording',
  GetPastEventsRecordings: 'Events/GetPastEventsRecordings',
  UploadImage: 'Events/UploadImage',
  Login: 'Auth/login-user',
};
